import { FormikProvider, useFormik } from 'formik';
import { Box, Flex } from 'reflexbox';
import { useTranslation } from 'react-i18next';

import { Button } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';
import useLocalize from 'packages/kakapo-ui-application/hooks/useLocalize';
import Paragraph from '../common/Paragraph';
import Modal, { ModalBackground, ModalContent } from '../modals/Modal';
import ModalHeader, { ModalHeaderTitle } from '../modals/ModalHeader';
import Label from '../forms/controls/Label';
import Field, { FieldType } from '../forms/controls/Field';
import Spinner from '../common/Spinner';
import GraphQLErrorMessage from '../forms/errors/GraphQLErrorMessage';

export default function CycleMomentSendReminderModal(props: {
	instance: graphql.MomentInstance;
	onDismiss: () => void;
}) {
	const { t } = useTranslation();
	const { localize } = useLocalize();

	const [commit, { loading, error }] = graphql.useSendMomentReminderMutation();

	const formik = useFormik({
		initialValues: {
			text: '',
		},
		onSubmit: async (values) => {
			await commit({
				variables: {
					input: {
						id: props.instance.id,
						text: values.text,
					},
				},
			});

			props.onDismiss();
		},
	});

	return (
		<ModalBackground>
			<Modal>
				<ModalHeader onCancel={() => props.onDismiss()}>
					<ModalHeaderTitle>{localize(props.instance.momentTemplate.title).text}</ModalHeaderTitle>
				</ModalHeader>
				<ModalContent>
					{loading ? (
						<Spinner isLoading size="18px" />
					) : (
						<>
							<Paragraph color="slateBlue">{t('inbox.cycle.moments.sendReminder.text')}</Paragraph>
							<FormikProvider value={formik}>
								<Label title={t('inbox.cycle.moments.sendReminder.description.label')} />
								<Field name="text" type={FieldType.Text} fullWidth />
							</FormikProvider>
							<GraphQLErrorMessage error={error?.graphQLErrors[0]} />
							<Flex justifyContent="flex-end">
								<Box mr={2}>
									<Button
										type="secondary"
										title={t('inbox.cycle.moments.sendReminder.cancelButton')}
										onClick={() => props.onDismiss()}
									/>
								</Box>
								<Button
									title={t('inbox.cycle.moments.sendReminder.skipButton')}
									onClick={() => formik.submitForm()}
								/>
							</Flex>
						</>
					)}
				</ModalContent>
			</Modal>
		</ModalBackground>
	);
}
